module.exports = __webpack_public_path__ + "static/media/logo_giztix.5b32bd52.svg";